import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

const ErrorFallback = ({ onRetry, error }) => {
  const handleRetry = () => {
    if (typeof onRetry === 'function') {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <Box
      role="alert"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: (theme) => theme.palette.background.default,
        padding: 2,
      }}
    >
      <Paper elevation={3} sx={{ maxWidth: 420, width: '100%', padding: 4 }}>
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <WarningAmberIcon color="error" sx={{ fontSize: 48 }} />
          <Typography component="h1" variant="h5">
            We ran into a problem
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
            }}
          >
            An unexpected error occurred. Please try again. If the problem persists, contact
            support.
          </Typography>
          {error?.message ? (
            <Typography
              variant="body2"
              sx={{
                color: 'text.disabled',
              }}
            >
              {error.message}
            </Typography>
          ) : null}
          <Button variant="contained" color="primary" onClick={handleRetry}>
            Try again
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default ErrorFallback;
